import { FEATURE_FLAG_DOMAIN } from '@heidi/runtime/feature-flags';
import { OpenFeature, useBooleanFlagValue } from '@openfeature/react-sdk';

const FLAG_KEY = 'release-scribe-no-speech-warning-mid-session';

/** FE-only mid-session no-speech warning, default OFF. */
export const useIsNoSpeechWarningMidSessionEnabled = (): boolean =>
  useBooleanFlagValue(FLAG_KEY, false);

/** Imperative gate for transcription callbacks outside React. */
export const isNoSpeechWarningMidSessionEnabled = (): boolean =>
  OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(FLAG_KEY, false);
